import { createSelector } from '@ngrx/store';
import { AppState } from '../app.states';
import { ICommonState } from './common.state';

export const getCommon = (state: AppState) => state.commonState;

export const commonState_IsFetching = createSelector(
  getCommon,
  (state: ICommonState) => state.isFetching
);

export const commonState_IsSending = createSelector(
  getCommon,
  (state: ICommonState) => state.isSending
);

export const commonState_LatestJourney = createSelector(
  getCommon,
  (state: ICommonState) => state.latestJourney
);